import React from "react";
import { useLanguage } from "../../hooks/useLanguage";

const Policy = () => {
  const { isKr } = useLanguage();
  return (
    <main className="bg-black pt-[130px] pb-[120px]">
      <div className="pc:w-[1144px] tablet:w-[688px] mb:w-[328px] m-auto text-white">
        <h1 className="font-bold text-[32px] mb-[48px]">
          {isKr ? "이용약관" : "Terms of Service"}
        </h1>

        {isKr ? <TermsKr /> : <TermsEn />}

        <div className="w-full h-[1px] bg-gray400 my-[80px]" />

        <h1 className="font-bold text-[32px] mb-[48px]">
          {isKr ? "개인정보 처리방침" : "Privacy Policy"}
        </h1>

        {isKr ? <PrivacyKr /> : <PrivacyEn />}
      </div>
    </main>
  );
};

export default Policy;

const Section = ({ title, children }: { title: string; children: React.ReactNode }) => (
  <div className="mb-[40px]">
    <h2 className="font-bold text-[20px] mb-[16px] text-mint">{title}</h2>
    <div className="text-[14px] leading-[180%] text-gray300 whitespace-pre-line">{children}</div>
  </div>
);

const TermsKr = () => (
  <>
    <Section title="제1조 (목적)">
      본 약관은 (주)휴컨(이하 "회사")이 운영하는 웹사이트(https://www.huconn.com)에서 제공하는 서비스(이하 "서비스")의 이용 조건 및 절차, 회사와 이용자의 권리·의무 및 책임사항을 규정함을 목적으로 합니다.
    </Section>
    <Section title="제2조 (정의)">
      {`① "웹사이트"란 회사가 서비스를 제공하기 위하여 운영하는 인터넷 사이트를 말합니다.
② "이용자"란 본 웹사이트에 접속하여 이 약관에 따라 회사가 제공하는 서비스를 이용하는 자를 말합니다.`}
    </Section>
    <Section title="제3조 (약관의 효력 및 변경)">
      {`① 본 약관은 웹사이트에 게시함으로써 효력이 발생합니다.
② 회사는 합리적인 사유가 발생할 경우 관련 법령에 위배되지 않는 범위 안에서 약관을 변경할 수 있으며, 변경된 약관은 웹사이트에 공지함으로써 효력이 발생합니다.`}
    </Section>
    <Section title="제4조 (서비스의 제공)">
      {`회사는 다음과 같은 서비스를 제공합니다.
① 회사 소개 및 사업 정보 제공
② 제품 및 기술 정보 제공
③ 채용 정보 제공
④ 고객 문의 서비스
⑤ 기타 회사가 정하는 서비스`}
    </Section>
    <Section title="제5조 (서비스의 변경 및 중단)">
      {`① 회사는 운영상, 기술상의 필요에 따라 서비스의 전부 또는 일부를 변경하거나 중단할 수 있습니다.
② 서비스 변경 또는 중단의 경우, 회사는 웹사이트를 통해 이를 사전에 공지합니다. 다만, 불가피한 사유가 있는 경우에는 사후에 공지할 수 있습니다.`}
    </Section>
    <Section title="제6조 (이용자의 의무)">
      {`이용자는 다음 행위를 하여서는 안 됩니다.
① 타인의 정보를 도용하는 행위
② 회사의 지적재산권을 침해하는 행위
③ 회사의 서비스 운영을 방해하는 행위
④ 기타 관련 법령에 위반되는 행위`}
    </Section>
    <Section title="제7조 (지적재산권)">
      본 웹사이트에 게시된 모든 콘텐츠(텍스트, 이미지, 로고, 영상 등)에 대한 지적재산권은 회사에 귀속됩니다. 이용자는 회사의 사전 서면 동의 없이 이를 복제, 배포, 전송, 수정, 출판할 수 없습니다.
    </Section>
    <Section title="제8조 (면책 조항)">
      {`① 회사는 천재지변, 전쟁, 기간통신사업자의 서비스 중지 등 불가항력적 사유로 서비스를 제공할 수 없는 경우에는 책임이 면제됩니다.
② 회사는 이용자의 귀책사유로 인한 서비스 이용 장애에 대하여 책임을 지지 않습니다.`}
    </Section>
    <Section title="제9조 (분쟁 해결)">
      {`① 본 약관에 관한 분쟁은 대한민국 법률에 따라 해결합니다.
② 서비스 이용과 관련하여 분쟁이 발생한 경우, 회사의 본사 소재지를 관할하는 법원을 전속 관할 법원으로 합니다.`}
    </Section>
    <Section title="부칙">
      본 약관은 2024년 1월 1일부터 시행합니다.
    </Section>
  </>
);

const TermsEn = () => (
  <>
    <Section title="Article 1 (Purpose)">
      These Terms of Service define the conditions and procedures for using the services provided by HUCONN Co., Ltd. (hereinafter "Company") through its website (https://www.huconn.com), as well as the rights, obligations, and responsibilities of the Company and its users.
    </Section>
    <Section title="Article 2 (Definitions)">
      {`① "Website" refers to the internet site operated by the Company to provide services.
② "User" refers to any person who accesses the website and uses the services provided by the Company in accordance with these Terms.`}
    </Section>
    <Section title="Article 3 (Effect and Amendment of Terms)">
      {`① These Terms become effective upon posting on the website.
② The Company may amend these Terms within the scope not violating relevant laws when reasonable grounds arise. Amended Terms become effective upon notice on the website.`}
    </Section>
    <Section title="Article 4 (Provision of Services)">
      {`The Company provides the following services:
① Company introduction and business information
② Product and technology information
③ Recruitment information
④ Customer inquiry service
⑤ Other services as determined by the Company`}
    </Section>
    <Section title="Article 5 (Modification and Suspension of Services)">
      {`① The Company may modify or suspend all or part of the services as needed for operational or technical reasons.
② In case of service modification or suspension, the Company shall provide prior notice through the website. However, notice may be given afterward in unavoidable circumstances.`}
    </Section>
    <Section title="Article 6 (User Obligations)">
      {`Users shall not engage in the following activities:
① Misappropriating another person's information
② Infringing on the Company's intellectual property rights
③ Interfering with the Company's service operations
④ Other activities that violate relevant laws`}
    </Section>
    <Section title="Article 7 (Intellectual Property)">
      All intellectual property rights for content posted on this website (text, images, logos, videos, etc.) belong to the Company. Users may not reproduce, distribute, transmit, modify, or publish such content without the Company's prior written consent.
    </Section>
    <Section title="Article 8 (Disclaimer)">
      {`① The Company is exempt from liability when services cannot be provided due to force majeure such as natural disasters, wars, or service interruptions by telecommunications carriers.
② The Company is not liable for service disruptions caused by the user's own fault.`}
    </Section>
    <Section title="Article 9 (Dispute Resolution)">
      {`① Disputes regarding these Terms shall be resolved in accordance with the laws of the Republic of Korea.
② In the event of a dispute arising from the use of services, the court having jurisdiction over the Company's headquarters shall serve as the exclusive court of jurisdiction.`}
    </Section>
    <Section title="Supplementary Provisions">
      These Terms shall be effective from January 1, 2024.
    </Section>
  </>
);

const PrivacyKr = () => (
  <>
    <Section title="제1조 (개인정보의 수집 및 이용 목적)">
      {`(주)휴컨(이하 "회사")은 다음의 목적을 위하여 개인정보를 처리합니다.
① 고객 문의 응대 및 처리
② 채용 지원자 관리
③ 웹사이트 이용 통계 분석 및 서비스 개선`}
    </Section>
    <Section title="제2조 (수집하는 개인정보 항목)">
      {`회사는 서비스 제공을 위해 다음과 같은 개인정보를 수집할 수 있습니다.
① 고객 문의: 이름, 이메일, 전화번호, 문의 내용
② 채용 지원: 이름, 연락처, 이메일, 학력, 경력, 자기소개서, 포트폴리오
③ 자동 수집: 접속 IP, 쿠키, 방문 일시, 브라우저 정보`}
    </Section>
    <Section title="제3조 (개인정보의 보유 및 이용 기간)">
      {`① 회사는 개인정보 수집 및 이용 목적이 달성된 후에는 해당 개인정보를 지체 없이 파기합니다.
② 다만, 관련 법령에 따라 보존이 필요한 경우에는 해당 법령에서 정한 기간 동안 보관합니다.
  - 전자상거래 등에서의 소비자 보호에 관한 법률에 따른 계약 또는 청약 철회 기록: 5년
  - 소비자 불만 또는 분쟁 처리에 관한 기록: 3년
  - 웹사이트 방문 기록: 3개월`}
    </Section>
    <Section title="제4조 (개인정보의 제3자 제공)">
      회사는 이용자의 개인정보를 원칙적으로 외부에 제공하지 않습니다. 다만, 이용자의 동의가 있거나 법령의 규정에 의한 경우에는 예외로 합니다.
    </Section>
    <Section title="제5조 (개인정보의 파기)">
      {`① 회사는 개인정보 보유 기간의 경과, 처리 목적 달성 등 개인정보가 불필요하게 되었을 때에는 지체 없이 해당 개인정보를 파기합니다.
② 전자적 파일 형태의 정보는 기록을 재생할 수 없는 기술적 방법을 사용하여 삭제합니다.
③ 종이에 출력된 개인정보는 분쇄기로 분쇄하거나 소각하여 파기합니다.`}
    </Section>
    <Section title="제6조 (이용자의 권리)">
      {`이용자는 언제든지 다음과 같은 권리를 행사할 수 있습니다.
① 개인정보 열람 요구
② 오류 등이 있을 경우 정정 요구
③ 삭제 요구
④ 처리 정지 요구

위 권리 행사는 회사에 이메일(huconn@huconn.com)로 요청하실 수 있습니다.`}
    </Section>
    <Section title="제7조 (개인정보 보호 책임자)">
      {`회사는 개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보 처리와 관련한 불만 처리 및 피해 구제를 위하여 아래와 같이 개인정보 보호 책임자를 지정하고 있습니다.

개인정보 보호 책임자: 강대근 (대표이사)
이메일: huconn@huconn.com
전화: 053-341-2613`}
    </Section>
    <Section title="부칙">
      본 개인정보 처리방침은 2024년 1월 1일부터 시행합니다.
    </Section>
  </>
);

const PrivacyEn = () => (
  <>
    <Section title="Article 1 (Purpose of Collection and Use of Personal Information)">
      {`HUCONN Co., Ltd. (hereinafter "Company") processes personal information for the following purposes:
① Responding to and processing customer inquiries
② Managing job applicants
③ Analyzing website usage statistics and improving services`}
    </Section>
    <Section title="Article 2 (Items of Personal Information Collected)">
      {`The Company may collect the following personal information to provide services:
① Customer inquiries: Name, email, phone number, inquiry details
② Job applications: Name, contact information, email, education, experience, cover letter, portfolio
③ Automatically collected: Access IP, cookies, visit date/time, browser information`}
    </Section>
    <Section title="Article 3 (Retention and Use Period of Personal Information)">
      {`① The Company shall destroy personal information without delay after the purpose of collection and use has been achieved.
② However, if retention is required under relevant laws, it shall be stored for the period specified by such laws.
  - Records of contracts or withdrawal under the Act on Consumer Protection in Electronic Commerce: 5 years
  - Records of consumer complaints or dispute resolution: 3 years
  - Website visit records: 3 months`}
    </Section>
    <Section title="Article 4 (Provision of Personal Information to Third Parties)">
      The Company does not, in principle, provide users' personal information to external parties. However, exceptions are made when the user consents or when required by law.
    </Section>
    <Section title="Article 5 (Destruction of Personal Information)">
      {`① The Company shall destroy personal information without delay when it is no longer needed, such as when the retention period has expired or the purpose of processing has been achieved.
② Information in electronic file format shall be deleted using technical methods that prevent reproduction.
③ Personal information printed on paper shall be destroyed by shredding or incineration.`}
    </Section>
    <Section title="Article 6 (User Rights)">
      {`Users may exercise the following rights at any time:
① Request to view personal information
② Request for correction of errors
③ Request for deletion
④ Request to suspend processing

The above rights may be exercised by contacting the Company via email (huconn@huconn.com).`}
    </Section>
    <Section title="Article 7 (Personal Information Protection Officer)">
      {`The Company designates a Personal Information Protection Officer as follows to oversee all matters related to personal information processing, and to handle complaints and remedies related to personal information processing.

Personal Information Protection Officer: Dae-Geun Kang (CEO)
Email: huconn@huconn.com
Phone: 053-341-2613`}
    </Section>
    <Section title="Supplementary Provisions">
      This Privacy Policy shall be effective from January 1, 2024.
    </Section>
  </>
);
